export const SET_REVIEW_DATA = 'SET_REVIEW_DATA';
